import React from 'react';

export default function PageLoader({ label = 'Loading...' }) {
  return (
    <div style={{ padding: '40px 20px', textAlign: 'center', color: '#445' }}>
      <div style={{ width: 40, height: 40, margin: '0 auto 12px', border: '4px solid #e6e8ef', borderTopColor: '#0f5ef7', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
      <div>{label}</div>
      <style>{`@keyframes spin {to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
